import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import LockToPlanContainer from '../../../../components/Editor/LockToPlanContainer';
import BaseCliScript2 from '../../AbstractObjects/GatewayPlan/InnerPages/BaseCliScript2';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import EmptyRow from '../../../../components/Simple/EmptyRow';
import Indentation from '../../../../components/Simple/Indentation';
import SMCTextArea from '../../../../components/Simple/SMCTextArea';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {dateAndTimeToString} from '../../../../utils/utils';
import {useTranslation} from 'react-i18next';
import SMCButton from '../../../../components/Simple/SMCButton';
import {cliScriptIcon} from "../../../../assets/images/headerIcons";

const pageSchema = GatewayGetSchema.pages.cliScript2;
const pageId = pageSchema.pageId;

function GatewayCliScript2({
    gatewayObject,
    planObject,
    setGatewayData,
    reloadGatewayCliResults
}) {
    const { t } = useTranslation();

    const gatewayPage = gatewayObject[pageId];
    const planPage = planObject[pageId];
    const lockedToPlan = gatewayPage[pageSchema.lockedToPlan];

    let currentPageData;
    if (lockedToPlan) {
        currentPageData = planPage;
    } else {
        currentPageData = gatewayPage;
    }

    const onToggleLockedToPlan = useCallback(locked => {
        // If unlocked page from plan, set all gateway fields to plan's fields
        if (!locked) {
            setGatewayData([pageId, pageSchema.manageInSmp], planPage[pageSchema.manageInSmp]);
            setGatewayData([pageId, pageSchema.script], planPage[pageSchema.script]);
        }
        setGatewayData([pageId, pageSchema.lockedToPlan], locked);

    }, [setGatewayData, planPage]);

    const scriptRunText      = gatewayPage[pageSchema.scriptRunText];
    const scriptRunTimestamp = gatewayPage[pageSchema.scriptRunTimestamp];

    return (
        <LockToPlanContainer
            locked={lockedToPlan}
            onToggleLocked={onToggleLockedToPlan}
            labelText={t('SMP.GATEWAYS.INNER_MENU.CLI_SCRIPT_2')}
            icon={cliScriptIcon}
        >
            <BaseCliScript2
                pageData={currentPageData}
                setObjectData={setGatewayData}
                pageDisabled={lockedToPlan}
            />
            <EmptyRow />
            <SMCLabel bold>{t('SMP.GATEWAYS.PAGE.CLI_SCRIPTS.LAST_SCRIPT_RESULT')}</SMCLabel>
            <Indentation>
                <EmptyRow />
                <SMCLabel bold>{t('SMP.GATEWAYS.PAGE.CLI_SCRIPTS.SCRIPT_OUTPUT')}</SMCLabel>
                <SMCTextArea
                    disabled={lockedToPlan}
                    value={scriptRunText}
                    width="580px"
                    height="140px"
                    style={{ fontFamily: 'monospace' }}
                />
                <SMCTextInput
                    readOnly
                    label={t('SMP.GATEWAYS.PAGE.CLI_SCRIPTS.LAST_STATUS_TIME')}
                    value={dateAndTimeToString(scriptRunTimestamp, true)}
                />
                <SMCButton
                    disabled={lockedToPlan}
                    style={{ margin: '7px 0' }}
                    onClick={() => reloadGatewayCliResults(pageId)}
                >
                    {t('SMP.GATEWAYS.PAGE.STATUS.REFRESH')}
                </SMCButton>
            </Indentation>
        </LockToPlanContainer>
    );
}

export default GatewayCliScript2;